export default "__VITE_ASSET__BLOuV2JL__"